import { Component, OnInit } from '@angular/core';
import {DataPatientCaseEndoRecallModel} from './models/data-patient-case-endo-recall.model';
import {RecallService} from '../../services/recall.service';
import {Globals} from '../../globals';
import {StaticDataService} from '../../services/static-data.service';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';
import {NotesService} from '../../services/notes.service';
import {FileManagerService} from '../file-manager/file-manager.service';
import {FileHelperService} from '../../services/file-helper.service';
import {PatientCaseEndoFinalReportDataModel} from '../../models/finalReport/patient-case-endo-final-report-data.model';
import {FinalReportService} from '../../services/final-report.service';
import {NoteDataModel} from '../../models/notes/note-data.model';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormArray, UntypedFormBuilder, FormControl, UntypedFormGroup} from '@angular/forms';
import {PatientCaseEndoRecallAutofillModel} from './models/patient-case-endo-recall-autofill.model';
import {MatDialog} from '@angular/material/dialog';
import {RecallPrintModalComponent, RecallPrintResult} from './recall-print-modal/recall-print-modal.component';
import {TdoNoteSaveModel} from '../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import {TreatmentEndoDataModel} from '../treatment/models/treatment-endo-data.model';
import {TreatmentService} from '../../services/treatment.service';
import {ReportConfigurationModel} from '../../models/configuration/report-configuration.model';
import {PatientCaseEndoRecallAutofillDetailModel} from './models/patient-case-endo-recall-autofill-detail.model';
import {DocumentDataModel} from '../../models/document/document-data.model';
import {DocumentDataImageModel} from '../../main-interface/controls/tdo-organizer/models/document-data-image.model';
import {enumSortBy} from '../imaging/image-organizer/io-toolbar/io-toolbar.component';
import {GetPatientImagesModel} from '../file-manager/models';
import {UiService} from '../../services/ui.service';
import {TdoNoteQueryModel} from '../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {NoteCategoryEnum} from "../../models/enum/note-category.enum";
import {NoteTypeEnum} from "../../models/enum/note-type.enum";
import {AuthenticationService} from '../auth/services/authentication.service';

@Component({
  selector: 'app-recall',
  templateUrl: './recall.component.html',
  styleUrls: ['./recall.component.scss']
})
export class RecallComponent implements OnInit {


  isLoading: boolean = true;

  recalls: DataPatientCaseEndoRecallModel[] = [];

  finalReport: PatientCaseEndoFinalReportDataModel = null;

  patientCase: string = '';

  sendRecallNow: boolean = true;

  notes: NoteDataModel[] = [];

  autoFills: PatientCaseEndoRecallAutofillModel[] = [];
  selectedSortMode: enumSortBy = enumSortBy.DateCreated;
  selectedTabIndex: number;

  selectedRecallType: string = '';

  selectedRecallForms: UntypedFormGroup;

  treatment: TreatmentEndoDataModel = null;

  autofillDetails: PatientCaseEndoRecallAutofillDetailModel[] = [];

  images: DocumentDataModel[] = [];
  thumbnailImages: DocumentDataImageModel[] = [];

  imageQuery: GetPatientImagesModel;

  probingValues: EnumValidValueItemModel[] = [];
  sinusValues: EnumValidValueItemModel[] = [];
  findingValues: EnumValidValueItemModel[] = [];
  mobilityValues: EnumValidValueItemModel[] = [];
  percussValues: EnumValidValueItemModel[] = [];
  palpValues: EnumValidValueItemModel[] = [];
  pdlidValues: EnumValidValueItemModel[] = [];
  lucencyValues: EnumValidValueItemModel[] = [];
  asymValues: EnumValidValueItemModel[] = [];
  coronalValues: EnumValidValueItemModel[] = [];
  restoredValues: EnumValidValueItemModel[] = [];
  timeValues: EnumValidValueItemModel[] = [];
  docTags: EnumValidValueItemModel[] = [];
  nextRecallOpts: EnumValidValueItemModel[] = [];
  statusEnums: EnumValidValueItemModel[] = [];
  recallEnums: EnumValidValueItemModel[] = [];
  prognosisEnums: EnumValidValueItemModel[] = [];
  medicalSpecialtyEnums: EnumValidValueItemModel[] = [];
  caseTypeEnums: EnumValidValueItemModel[] = [];
  restorationMethodEnums: EnumValidValueItemModel[] = [];
  treatmentSessionsEnums: EnumValidValueItemModel[] = [];
  caseRatingEnums: EnumValidValueItemModel[] = [];

  reports: ReportConfigurationModel[] = [];

  constructor(
    public recallService: RecallService,
    public globals: Globals,
    public staticDataService: StaticDataService,
    public noteService: NotesService,
    public fileService: FileManagerService,
    public fileHelper: FileHelperService,
    public reportService: FinalReportService,
    public snackBar: MatSnackBar,
    public formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    public treatmentService: TreatmentService,
    public docService: FileManagerService,
    private uiService: UiService,
    private notesService: NotesService,
    private authenticationService: AuthenticationService
  )
  {
    this.isLoading = true;
    this.imageQuery = {
      PatientID: this.globals.currentPatientId,
      enumDocumentClassID: '',
      enumDocumentFolderTypeID: '',
      DocumentFolderID: '',
      enumDocumentTagIDs: [],
      WorkItemEventID: '',
      Options: {IsAscending: true, PropertyToSortBy: this.selectedSortMode}
    };
    this.patientCase = this.globals.currentPatientCaseId;
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    } else {
      this.setupEnums();
    }
    this.recallService.getRecalls(this.globals.currentPatientCaseId).subscribe( (res) => {
      this.recalls = res;
      console.log(res);
    });
    if (this.recalls.length < 1) {
      const newRecall = new DataPatientCaseEndoRecallModel();
      newRecall.PatientCaseId = this.patientCase;
      newRecall.xauditCreatedOn = new Date();
      this.recalls.push(newRecall);
      this.selectedTabIndex = this.recalls.indexOf(newRecall);
      if (this.finalReport !== null) {
        newRecall.CaseRecallID = this.finalReport.CaseFinalReportID;
      }
    }
    this.docService.getPatientImages(this.imageQuery).subscribe( res => {
      this.images = res.Documents;
    });
  }

  async ngOnInit() {
    this.reportService.getFinalReport(this.patientCase).subscribe( (res) => {
      this.finalReport = res;
      // tslint:disable-next-line:prefer-for-of
      for ( let i = 0; i < this.recalls.length; i++) {
        this.recalls[i].PatientCaseId = this.finalReport.CaseFinalReportID;
      }
      console.log(this.finalReport.dataPatientCaseEndoFinalReportRestorRecomds);
    });
    this.treatmentService.getTreatment(this.globals.currentPatientId, this.patientCase).subscribe(res => {
      this.treatment = res;
    });
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.images.length; i++) {
      this.docService.getDocumentURL(this.images[i].DocumentID).subscribe( (res) => {
        const newImage: DocumentDataImageModel = {
          CaseWorkItemId: this.images[i].CaseWorkItemId,
          Description: this.images[i].Description,
          DocumentCreateDate: this.images[i].DocumentCreateDate,
          DocumentFileName: this.images[i].DocumentFileName,
          DocumentID: this.images[i].DocumentID,
          DocumentModifiedDate: this.images[i].DocumentModifiedDate,
          DocumentOrder: this.images[i].DocumentOrder,
          ImageSpreadPKID: this.images[i].ImageSpreadPKID,
          LOCID: this.images[i].LOCID,
          ParentDocumentID: this.images[i].ParentDocumentID,
          PatientCaseId: this.images[i].PatientCaseId,
          PatientId: this.images[i].PatientCaseId,
          WorkItemEventId: this.images[i].WorkItemEventId,
          dataDocumentTags: this.images[i].dataDocumentTags,
          description: this.images[i].Description,
          enumDocumentFileTypeID: this.images[i].enumDocumentFileTypeID,
          enumDocumentTypeID: this.images[i].enumDocumentTypeID,
          enumDocumentClassID: '',
          PhysicalFileName: '',
          imageSource: res,
          model: res.model,
          xauditCreatedBy: this.images[i].xauditCreatedBy,
          xauditCreatedOn: this.images[i].xauditCreatedOn,
          xauditDeleted: this.images[i].xauditDeleted,
          xauditModifiedBy: this.images[i].xauditModifiedBy,
          xauditModifiedOn: this.images[i].xauditModifiedOn,
          xauditTableRowID: this.images[i].xauditTableRowID,
          row: null,
          hasAnnotation: false,
          DeviceID: '',
          listOfTeeth: '',
          caseName: ''
        };
        this.thumbnailImages.push(newImage);
      });
    }
    this.recallService.getAutoFills().subscribe( res => {
      this.autoFills = res;
      console.log(this.autoFills);
    });
    this.isLoading = false;
    console.log(this.recalls);
  }

  setupEnums() {
    this.probingValues = this.staticDataService.getValidValueItemsByValidValueName('enumProbingDepth');
    this.sinusValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallSinusTrack');
    this.findingValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallCurrentFinding');
    this.mobilityValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallMobility');
    this.percussValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallPercuss');
    this.palpValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallPalpSore');
    this.pdlidValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallPDL');
    this.lucencyValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallLucencyI');
    this.asymValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallAsymFunc');
    this.coronalValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallCoronalLeak');
    this.restoredValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallToothResored');
    this.timeValues = this.staticDataService.getValidValueItemsByValidValueName('enumEndoRecallInTime');
    const allTags = this.staticDataService.getValidValueItemsByValidValueName('enumDocumentTag');
    this.nextRecallOpts = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRecall');
    this.statusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportCaseStatus');
    this.prognosisEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportPrognosis');
    this.recallEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRecall');
    this.medicalSpecialtyEnums = this.staticDataService.getValidValueItemsByValidValueName('enumMedicalSpecialty');
    this.caseTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseType');
    this.restorationMethodEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRestorationMethod');
    this.treatmentSessionsEnums = this.staticDataService.getValidValueItemsByValidValueName('enumTreatmentSessions');
    this.caseRatingEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseRating');

    // for (let i = 0; allTags.length; i++) {
    //   if (allTags[i].ItemDisplayValue.includes('recall')) {
    //     this.docTags.push(allTags[i]);
    //   }
    // }
  }

  // buildForm() {
  //   // @ts-ignore: next-line
  //   let newFormArray: FormArray = [];
  //   for (let i = 0; this.recalls.length; i++) {
  //     const newFormGroup = this.formBuilder.group({
  //       probingMB_enumProbingDepthID: new FormControl(),
  //       probingM_enumProbingDepthID: new FormControl(),
  //       probingML_enumProbingDepthID: new FormControl(),
  //       probingL_enumProbingDepthID: new FormControl(),
  //       probingDB_enumProbingDepthID: new FormControl(),
  //       probingB_enumProbingDepthID: new FormControl(),
  //       probingDL_enumProbingDepthID: new FormControl(),
  //       probingD_enumProbingDepthID: new FormControl(),
  //       enumEndoRecallCurrentFindingID: new FormControl()
  //     });
  //     newFormArray.push(newFormGroup);
  //   }
  //   this.selectedRecallForms = newFormArray;
  // }

  selectRecall(recall: DataPatientCaseEndoRecallModel) {
    this.selectedTabIndex = this.recalls.indexOf(recall);
  }

  isSendRecall(recall: DataPatientCaseEndoRecallModel) {
    recall.isSendRecallReport = !recall.isSendRecallReport;
    this.sendRecallNow = recall.isSendRecallReport;
  }

  async saveAutofill(recall: DataPatientCaseEndoRecallModel) {
    this.isLoading = true;
    const newAutofill = new PatientCaseEndoRecallAutofillModel();
    let newDetail: PatientCaseEndoRecallAutofillDetailModel;
    newAutofill.AutofillName = (this.autoFills.length + 1).toString();
    await this.recallService.saveAutoFill(newAutofill).subscribe( res => {
      const selectedAutofill = res;
      this.autoFills.push(selectedAutofill);
      newDetail = {
        AutoFillID: selectedAutofill.AutofillID,
        AutofillDetailID: '',
        Comment: '',
        enumEndoRecallAsymFuncID: recall.enumEndoRecallAsymFuncID,
        enumEndoRecallCoronalLeakID: recall.enumEndoRecallCoronalLeakID,
        enumEndoRecallCurrentFindingID: recall.enumEndoRecallCurrentFindingID,
        enumEndoRecallInTimeID: recall.enumEndoRecallInTimeID,
        enumEndoRecallLucencyID: recall.enumEndoRecallLucencyID,
        enumEndoRecallMobilityID: recall.enumEndoRecallMobilityID,
        enumEndoRecallPDLID: recall.enumEndoRecallPDLID,
        enumEndoRecallPalpSoreID: recall.enumEndoRecallPalpSoreID,
        enumEndoRecallPercussID: recall.enumEndoRecallPercussID,
        enumEndoRecallSinusTrackID: recall.enumEndoRecallSinusTrackID,
        enumEndoRecallToothResoredID: recall.enumEndoRecallToothResoredID,
        isSendRecallReport: recall.isSendRecallReport,
        probingB_enumProbingDepthID: recall.probingB_enumProbingDepthID,
        probingDB_enumProbingDepthID: recall.probingDB_enumProbingDepthID,
        probingDL_enumProbingDepthID: recall.probingDL_enumProbingDepthID,
        probingD_enumProbingDepthID: recall.probingD_enumProbingDepthID,
        probingL_enumProbingDepthID: recall.probingL_enumProbingDepthID,
        probingMB_enumProbingDepthID: recall.probingMB_enumProbingDepthID,
        probingML_enumProbingDepthID: recall.probingML_enumProbingDepthID,
        probingM_enumProbingDepthID: recall.probingM_enumProbingDepthID,
        xauditCreatedBy: '',
        xauditCreatedOn: undefined,
        xauditDeleted: false,
        xauditModifiedBy: '',
        xauditModifiedOn: undefined,
        xauditTableRowID: ''
      };
    });
    await this.recallService.saveAutoFillDetail(newDetail).subscribe( (data) => {
      this.autofillDetails.push(data);
      this.isLoading = false;
    });
    this.snackBar.open('Autofill Saved!', 'Alert', {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  applyAutoFill(autofillID: string, recall: DataPatientCaseEndoRecallModel) {
    const recallIndex = this.recalls.indexOf(recall);
    let selectedDetail: PatientCaseEndoRecallAutofillDetailModel;
    this.recallService.getAutoFillDetail(autofillID).subscribe( res => {
      selectedDetail = res;
    });
    recall = {
      CaseFinalReportID: recall.CaseFinalReportID,
      CaseRecallID: recall.CaseRecallID,
      PatientCaseId: recall.PatientCaseId,
      RecallReportSentBy: recall.RecallReportSentBy,
      RecallReportSentOn: recall.RecallReportSentOn,
      enumEndoRecallAsymFuncID: selectedDetail.enumEndoRecallAsymFuncID,
      enumEndoRecallCoronalLeakID: selectedDetail.enumEndoRecallCoronalLeakID,
      enumEndoRecallCurrentFindingID: selectedDetail.enumEndoRecallCurrentFindingID,
      enumEndoRecallInTimeID: selectedDetail.enumEndoRecallInTimeID,
      enumEndoRecallLucencyID: selectedDetail.enumEndoRecallLucencyID,
      enumEndoRecallMobilityID: selectedDetail.enumEndoRecallMobilityID,
      enumEndoRecallPDLID: selectedDetail.enumEndoRecallPDLID,
      enumEndoRecallPalpSoreID: selectedDetail.enumEndoRecallPalpSoreID,
      enumEndoRecallPercussID: selectedDetail.enumEndoRecallPercussID,
      enumEndoRecallSinusTrackID: selectedDetail.enumEndoRecallSinusTrackID,
      enumEndoRecallToothResoredID: selectedDetail.enumEndoRecallToothResoredID,
      isRecallReportSent: recall.isRecallReportSent,
      isSendRecallReport: recall.isSendRecallReport,
      probingB_enumProbingDepthID: selectedDetail.probingB_enumProbingDepthID,
      probingDB_enumProbingDepthID: selectedDetail.probingDB_enumProbingDepthID,
      probingDL_enumProbingDepthID: selectedDetail.probingDL_enumProbingDepthID,
      probingD_enumProbingDepthID: selectedDetail.probingD_enumProbingDepthID,
      probingL_enumProbingDepthID: selectedDetail.probingL_enumProbingDepthID,
      probingMB_enumProbingDepthID: selectedDetail.probingMB_enumProbingDepthID,
      probingML_enumProbingDepthID: selectedDetail.probingML_enumProbingDepthID,
      probingM_enumProbingDepthID: selectedDetail.probingL_enumProbingDepthID,
      xauditCreatedBy: recall.xauditCreatedBy,
      xauditCreatedOn: recall.xauditCreatedOn,
      xauditDeleted: recall.xauditDeleted,
      xauditModifiedBy: recall.xauditModifiedBy,
      xauditModifiedOn: recall.xauditModifiedOn,
      xauditTableRowID: recall.xauditTableRowID,
      ActualRecallDate: new Date(),
      for_RecallDate: new Date(),
      for_enumEndoRecallInTimeID:  '',
      CaseWorkItemFormsId: ''
    };
    console.log(recall);
    this.recalls.splice(recallIndex, 1, recall);
    return this.recalls;
  }

  sendToNote(recall: DataPatientCaseEndoRecallModel) {
    const summary = JSON.stringify(recall);
    const newNote: TdoNoteSaveModel = {
      associatedObjects: [{parentObjectName: 'Recall' + recall.CaseRecallID, objectId: recall.PatientCaseId}],
      categoryEnumIds: [],
      dataNote: undefined,
      patientId: this.globals.currentPatientId,
      text: summary,
      typeEnumIds: []
    };
    this.noteService.saveNote(newNote).subscribe( res => {
      this.notes = [res];
      this.snackBar.open('Note Saved!', 'Alert', {
        duration: 3000,
        verticalPosition: 'top'
      });
    });

  }

  compareFn(option1: string, option2: EnumValidValueItemModel): boolean {
    return option1 && option2 ? option1 === option2.ValidValueItemId : false;

  }


  sendRecall(recall: DataPatientCaseEndoRecallModel) {
    recall.isRecallReportSent = true;
    recall.RecallReportSentBy = this.authenticationService.currentUserValue.authdata.userid;
    recall.RecallReportSentOn = new Date();
    console.log('Recall Sent! ' + JSON.stringify(recall));
  }

  removeTab($event: MouseEvent) {
    if ( this.recalls[this.selectedTabIndex].CaseRecallID !== '') {
      this.recallService.deleteRecall(this.recalls[this.selectedTabIndex]);
      // this.recalls[this.selectedTabIndex].xauditDeleted = true;
      // this.recallService.saveRecalls(this.recalls).subscribe( res => {
      //   this.recalls = res;
      // });
      this.recalls.splice(this.selectedTabIndex, 1);
      this.selectedTabIndex = this.selectedTabIndex - 1;
    } else {
        this.snackBar.open('Error Deleting this Recall', 'Error', {
          duration: 3000,
          verticalPosition: 'top'
        });
      }
    return this.selectedTabIndex && this.recalls;
  }

  selectTab(i: number) {
    this.selectedTabIndex = i;
    // this.buildForm();
  }

  onTabChange(event: MatTabChangeEvent) {
    this.getSelectedIndex();

    const recall = this.recalls[event.index];
    const noteQueryModel = new TdoNoteQueryModel();
    noteQueryModel.parentObjectName = 'dataPatientCaseEndoRecall';
    noteQueryModel.objectId = recall.CaseRecallID;
    noteQueryModel.patientId = this.globals.currentPatientId;
    noteQueryModel.categoryEnumId = NoteCategoryEnum.Recall;
    noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
    this.notesService.changeNoteQuery(noteQueryModel);

    // this.buildForm();
    console.log(this.recalls);
    return this.recalls;
  }

  getSelectedIndex(): number {
    return this.selectedTabIndex;
  }

  onNewTabClick($event: MouseEvent) {
    // if (this.recalls.length < 10) {
      const newRecall = new DataPatientCaseEndoRecallModel();
      newRecall.PatientCaseId = this.patientCase;
      newRecall.xauditCreatedOn = new Date();
      this.recalls.push(newRecall);
      this.selectedTabIndex = this.recalls.indexOf(newRecall);
    // } else {
    //   this.snackBar.open('Maximum of 10 recalls reached', 'Error', {
    //     duration: 3000,
    //     verticalPosition: 'top'
    //   });
    // }
  }

  onRestoredChange(item: EnumValidValueItemModel, tab: DataPatientCaseEndoRecallModel) {
    tab.enumEndoRecallToothResoredID = item.ValidValueItemId;
    console.log(tab);
  }

  onCoronalChange(item: EnumValidValueItemModel, tab: DataPatientCaseEndoRecallModel) {
    tab.enumEndoRecallCoronalLeakID = item.ValidValueItemId;
    console.log(tab);
  }

  onAsymChange(item: EnumValidValueItemModel, tab: DataPatientCaseEndoRecallModel) {
    tab.enumEndoRecallAsymFuncID = item.ValidValueItemId;
    console.log(tab);
  }

  onLucencyChange(item: EnumValidValueItemModel, tab: DataPatientCaseEndoRecallModel) {
    tab.enumEndoRecallLucencyID = item.ValidValueItemId;
    console.log(tab);
  }

  onPDLChange(item: EnumValidValueItemModel, tab: DataPatientCaseEndoRecallModel) {
    tab.enumEndoRecallPDLID = item.ValidValueItemId;
    console.log(tab);
  }

  onPalpChange(item: EnumValidValueItemModel, tab: DataPatientCaseEndoRecallModel) {
    tab.enumEndoRecallPalpSoreID = item.ValidValueItemId;
    console.log(tab);
  }

  onPercussChange(item: EnumValidValueItemModel, tab: DataPatientCaseEndoRecallModel) {
    tab.enumEndoRecallPercussID = item.ValidValueItemId;
    console.log(tab);
  }

  onMobilityChange(item: EnumValidValueItemModel, tab: DataPatientCaseEndoRecallModel) {
    tab.enumEndoRecallMobilityID = item.ValidValueItemId;
    console.log(tab);
  }

  onSinusChange(item: EnumValidValueItemModel, tab: DataPatientCaseEndoRecallModel) {
    tab.enumEndoRecallSinusTrackID = item.ValidValueItemId;
    console.log(tab);
  }

  openDrawInNewWindow(): void {
    this.uiService.openImagingWindow();
  }

  openAcquireInNewWindow(): void {
    window.open('/landing/acquire', '_blank', 'toolbar=1,location=1,menubar=1');
  }


  printPDF() {
    const dialogRef = this.dialog.open(RecallPrintModalComponent, {
      width: '600px',
      height: '800px',
      disableClose: true,
      data: {recalls: this.recalls, finalReport: this.finalReport, notes: this.notes, images: this.images}
    });

    dialogRef.afterClosed().subscribe((result: RecallPrintResult) => {
      if (result.printed === true) {
        this.snackBar.open('Print Successful', 'Alert', {
          duration: 3000,
          verticalPosition: 'top'
        });
      }
    });
  }

  superRecall() {
    if (this.finalReport !== null) {
      this.finalReport.isSuperRecall = !this.finalReport.isSuperRecall;
    } else {
      this.snackBar.open('No Final Report', 'Alert', {
        duration: 3000,
        verticalPosition: 'top'
      });
      console.log('No Final Report');
    }
  }

  selectNextRecall(option: EnumValidValueItemModel) {
    switch (option !== null){

    }
  }

  onSubmit() {
    this.isLoading = true;
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.recalls.length; i++) {
      this.recallService.saveRecalls(this.recalls).subscribe( (res) => {
        this.recalls = res;
        console.log(res);
      });
      this.snackBar.open('Save Successful!', 'Alert', {
        duration: 3000,
        verticalPosition: 'top'
      });
    }
    this.isLoading = false;
  }

}
